import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { OccupationModal } from '../../../sharedcomponents/commonservice/occupation/Occupation/Occupation.Modal';
import { AppSettings } from '../../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { carddetail } from '../../../models/mywallet/card/mywallet.card.Modal';
import { SpanishCharConverstion } from '../../../sharedcomponents/commonservice/SpanishTextHandling.service';

@Injectable()
export class mywalletcard {
  constructor(private http: Http, private utilserv: utilityService, private spanishConvert: SpanishCharConverstion) { }
  //1 Envolpe for
  getcardlistservice(AlreadyUsedFunding: String) {
    return this.utilserv.soapPostwithoutAction(this.getcardlistenvolpe(AlreadyUsedFunding), AppSettings.get_debit_card_url);
  }
  getcardlistenvolpe(AlreadyUsedFunding: String) {
    let envelope: string = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                                        <s:Header>
                                            <a:Action s:mustUnderstand="1">http://tempuri.org/IGetCardFromWallet/GetFundingDetailsT2Based</a:Action>

                                            <a:MessageID>urn:uuid:faf34082-072e-4a2a-9e84-f096678f015f</a:MessageID>
                                            <a:ReplyTo>
                                            <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                                            </a:ReplyTo>
                                        </s:Header>
                                        <s:Body>
                                            <GetFundingsRequest  xmlns="http://tempuri.org/">
                                            <AlreadyUsedFunding>${AlreadyUsedFunding}</AlreadyUsedFunding>
                                            <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                                            <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.Wallet.Contracts.DataContracts" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                            <d4p1:T1></d4p1:T1>
                                            <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                                            </Session>
                                            </GetFundingsRequest>
                                        </s:Body>
                                     </s:Envelope>`;
    return envelope;
  }

  deleteCardservice(fundingID: String) {
    return this.utilserv.soapPostwithoutAction(this.deleteCardenvolpe(fundingID), AppSettings.get_debit_card_url);
  }
  deleteCardenvolpe(fundingID) {
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing"
                         xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                  <s:Header>
                        <a:Action s:mustUnderstand="1">http://tempuri.org/IGetCardFromWallet/DeleteFundingID</a:Action>
                        <a:MessageID>urn:uuid:5aea889e-f5c3-423d-911b-55d5e876fe09</a:MessageID>
                        <a:ReplyTo>
                              <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                        </a:ReplyTo>
                  </s:Header>
                  <s:Body>
                      <DeleteFundingRequest xmlns="http://tempuri.org/">
                            <FundingID>${fundingID}</FundingID>
                            <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                              <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.Wallet.Contracts.DataContracts"
                                                  xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                            <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                                            <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                              </Session>
                      </DeleteFundingRequest>
                  </s:Body>
             </s:Envelope>`;
    return envelope;
  }

  addcardservice(cardmodal: carddetail) {
    return this.utilserv.soapPostwithoutAction(this.addcardenvolpe(cardmodal), AppSettings.add_debit_card_url);
  }
  registercardonice(fundingResponse, cardInfoModal) {

    try {
      const cardModal: any = {};
      let registraion = '';
      let enrollmentTokens: string;
      let fundingToken: string;
      let paymentProcessToken;
      let loopCounter = 0;
      let loopCounterEnrollment = 0;
      let loopCounterFunding = 0;

      let objRegArray = this.utilserv.getArray(fundingResponse.FundingActivationCode.Registrations.CardRegistrationDefinition);

      if (fundingResponse.FundingActivationCode.Registrations.CardRegistrationDefinition !== undefined) {
        for (loopCounter = 0; loopCounter < objRegArray.length; loopCounter++) {
          // Enrollment tokens
          const tokenArray = objRegArray[loopCounter].EnrollmentTokens.KeyValueOfstringstring;
          if (tokenArray !== undefined && tokenArray.length > 1) {
            for (loopCounterEnrollment = 0; loopCounterEnrollment < tokenArray.length; loopCounterEnrollment++) {
              if (loopCounterEnrollment === 0) {
                enrollmentTokens = `"${this.utilserv.getObjectText(tokenArray[loopCounterEnrollment].Key)}":"${this.utilserv.getObjectText(tokenArray[loopCounterEnrollment].Value)}",`;
              } else {
                enrollmentTokens += `"${this.utilserv.getObjectText(tokenArray[loopCounterEnrollment].Key)}":"${this.utilserv.getObjectText(tokenArray[loopCounterEnrollment].Value)}",`;
              }
            }

            enrollmentTokens = enrollmentTokens.slice(0, -1);
          } else {
            enrollmentTokens = '{}';
          }
          // Funding Token
          const fundingTokenArray = objRegArray[loopCounter].FundingTokens.KeyValueOfstringstring;
          if (fundingTokenArray !== undefined && fundingTokenArray.length > 1) {
            for (loopCounterFunding = 0; loopCounterFunding < fundingTokenArray.length; loopCounterFunding++) {
              if (loopCounterFunding === 0) {
                fundingToken = `"${this.utilserv.getObjectText(fundingTokenArray[loopCounterFunding].Key)}":"${this.utilserv.getObjectText(fundingTokenArray[loopCounterFunding].Value)}",`;
              } else {
                fundingToken += `"${this.utilserv.getObjectText(fundingTokenArray[loopCounterFunding].Key)}":"${this.utilserv.getObjectText(fundingTokenArray[loopCounterFunding].Value)}",`;
              }
            }
            fundingToken = fundingToken.slice(0, -1);
            //console.log(fundingToken);
          } else {
            fundingToken = '{}';
            //console.log(fundingToken);
          }
          //.PaymentProcessorKey
          paymentProcessToken = this.utilserv.getObjectText(objRegArray[loopCounter].PaymentProcessorKey);

          registraion += `{"EnrollmentTokens":{${enrollmentTokens}},
                        "FundingTokens":${fundingToken},
                        "PaymentProcessorKey":"${paymentProcessToken}"},`;
          //console.log("payment processor token and regiasteration envelope" + registraion);
        }
      }

      //cardModal.EnrollmentTokens = enrollmentTokens;
      //cardModal.FundingTokens

      cardModal.CardRegistrationCode = this.utilserv.getObjectText(fundingResponse.FundingActivationCode.CardRegistrationCode);
      cardModal.cardNumber = cardInfoModal.cardnumber;
      cardModal.CVV = cardInfoModal.CVV;
      cardModal.Registration = registraion;

      return this.utilserv.restPost(this.validateCardICE(cardModal), AppSettings.verifyCard);
    } catch (ex) {
      //console.log(ex);
    }
  } debuger
  validateCardICE(cardModal) {
    const envelope = `{
                          "AccountNumber":"${cardModal.cardNumber}",
                          "SecurityCode":"${cardModal.CVV}",
                          "Registrations": [${cardModal.Registration.slice(0, -1)}],
                          "CardRegistrationCode":"${cardModal.CardRegistrationCode}"
                        }`;

    //     const envelope = `{
    //   "AccountNumber": "5100270123456789",
    //   "CardRegistrationCode": "${cardModal.CardRegistrationCode}",
    //   "Registrations": [
    //     {
    //       "EnrollmentTokens": {
    //         "ICE_ENROLLMENT_ID": "2052e17d20954172a998529114eeba53",
    //         "ENROLLMENT_ID": "16258867",
    //         "ACCOUNT_ID": "15540401"
    //       },
    //       "FundingTokens": {},
    //       "PaymentProcessorKey": "ALACRITI"
    //     }
    //   ],
    //   "SecurityCode": "123"
    // }`;
    //console.log("this is envelope of validate card" + envelope);
    return envelope;
  }


  addcardenvolpe(cardmodel: carddetail) {
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
    <s:Header>
    <a:Action s:mustUnderstand="1">http://tempuri.org/IAddCardToWallet/GetPaymentActivationCode</a:Action>
    <a:MessageID>urn:uuid:192e3246-dec6-4de0-98c7-041f4a9bebe2</a:MessageID>
    <a:ReplyTo>
    <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
    </a:ReplyTo>
    </s:Header>
    <s:Body>
    <GetPaymentActivationCodeRequest xmlns="http://tempuri.org/">
    <AccountNumber>${cardmodel.lastfourcardnumber}</AccountNumber>
    <AlternateAddress xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.Wallet.Contracts.DataContracts" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
    <d4p1:Address>${this.spanishConvert.removeDiacritics(cardmodel.Address.trim(), true)}</d4p1:Address>
    <d4p1:City>${cardmodel.City}</d4p1:City>
    <d4p1:CountryCode>${cardmodel.CountryCode}</d4p1:CountryCode>
    <d4p1:PostalCode>${cardmodel.PostalCode}</d4p1:PostalCode>
    <d4p1:StateCode>${cardmodel.StateCode}</d4p1:StateCode>
    </AlternateAddress>
    <AlternateName>${this.spanishConvert.removeDiacritics(cardmodel.FriendlyName.trim(), true)}</AlternateName>
    <Description>${this.spanishConvert.removeDiacritics(cardmodel.FriendlyName.trim(), true)}</Description>
    <ExpirationMonth>${cardmodel.ExpirationMonth}</ExpirationMonth>
    <ExpirationYear>${cardmodel.ExpirationYear}</ExpirationYear>
    <InstitutionName></InstitutionName>
    <LanguageCode>${sessionStorage.langCode}</LanguageCode>
    <NameOnAccount>${this.spanishConvert.removeDiacritics(cardmodel.NameOnAccount.trim(), true)}</NameOnAccount>
    <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.Wallet.Contracts.DataContracts" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
    <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
    <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
    </Session>
    <SubType>${cardmodel.CardSubType}</SubType>
    <Type>${cardmodel.PaymentType}</Type>
    </GetPaymentActivationCodeRequest>
    </s:Body>
    </s:Envelope>`;

    return envelope;
    
  }
  validatecreditcard(cardnumber) {
    var store = new Map<string, string>();
    if (/\b5[12345]\d{14}\b/.test(cardnumber)) {
      //Master
      store.set('cardsubtype', ICE_CardSubType.master.toString());
      store.set('cardtype', ICE_CardType.debitCard.toString());
      return store;
    } else if (/\b4\d{12}(?:\d{3})?\b/.test(cardnumber)) {
      //Visa
      store.set('cardsubtype', ICE_CardSubType.visa.toString());
      store.set('cardtype', ICE_CardType.debitCard.toString());
      return store;
    } else if (/^6(?:011|5[0-9]{2})[0-9]{3,}$/.test(cardnumber)) {
      //Discover
      store.set('cardsubtype', ICE_CardSubType.discover.toString());
      store.set('cardtype', ICE_CardType.debitCard.toString());
      return store;
    } else if (/^3[47][0-9]{5,}/.test(cardnumber)) {
      //  Amex
      store.set('cardsubtype', ICE_CardSubType.amex.toString());
      store.set('cardtype', ICE_CardType.debitCard.toString());
      return store;
    } else {
      store.set('cardsubtype', ICE_CardSubType.unknown.toString());
      store.set('cardtype', ICE_CardType.debitCard.toString());
      return store;
    } //Invaid
  }
}

//CardSubType enum
enum ICE_CardSubType {
  unknown = -1,
  master = 0,
  visa = 1,
  discover = 2,
  amex = 3,
  personalChecking = 4,
  personalSavings = 5
}

//Debit Card Type
export enum ICE_DebitCard {
  Unknown = -1,
  Visa = 1,
  MasterCard = 0,
  discover = 2,
  amex = 3
}
//Card Type enum
export enum ICE_CardType {
  creditCard = 0,
  debitCard = 1,
  bankAccount = 2
}



// WEBPACK FOOTER //
// ./src/app/_services/mywallet/card/mywallet.card.service.ts